import React, { useState } from 'react';

const NODES = [
  { id: 'n01', x: 10, y: 160, w: 95, h: 65, label: '01: DISCOVER', name: 'News Discovery', detail: 'RSS, LME, Reuters', color: '#34d399', status: 'Active' },
  { id: 'n02', x: 120, y: 160, w: 95, h: 65, label: '02: EXTRACT', name: 'Source Extract', detail: 'Facts & entities', color: '#38bdf8', status: 'Streaming' },
  { id: 'n03', x: 230, y: 160, w: 95, h: 65, label: '03: COMPARE', name: 'Source Compare', detail: 'Cross-reference', color: '#38bdf8', status: 'Active' },
  { id: 'n04', x: 340, y: 160, w: 95, h: 65, label: '04: VERIFY', name: 'Fact Verifier', detail: 'Claims validation', color: '#fbbf24', status: '98.2% Conf' },
  { id: 'n05', x: 340, y: 60, w: 95, h: 65, label: '05: RESEARCH', name: 'Deep Research', detail: 'Conflict resolve', color: '#a855f7', status: 'Conditional' },
  { id: 'n06', x: 450, y: 160, w: 95, h: 65, label: '06: DRAFT', name: 'Article Gen', detail: 'Claude 3.5 Sonnet', color: '#c084fc', status: 'Synthesizing' },
  { id: 'n07', x: 560, y: 160, w: 95, h: 65, label: '07: STYLE', name: 'Style Validate', detail: 'AlCircle tone', color: '#34d399', status: '99% Match' },
  { id: 'n08', x: 670, y: 160, w: 95, h: 65, label: '08: PLAGIARISM', name: 'Plagiarism Chk', detail: 'TF-IDF scoring', color: '#34d399', status: 'Verified' },
  { id: 'n09', x: 670, y: 60, w: 95, h: 65, label: '09: REWRITE?', name: 'Rewrite Gate', detail: 'Quality routing', color: '#fbbf24', status: 'Passthrough' },
  { id: 'n10', x: 560, y: 60, w: 95, h: 65, label: '10: REWRITE', name: 'Rewrite Agent', detail: 'Max 2 loops', color: '#f97316', status: 'Conditional' },
  { id: 'n11', x: 780, y: 120, w: 95, h: 65, label: '11: IMAGEN', name: 'Imagen4 Hero', detail: 'Google Imagen 4', color: '#89ceff', status: 'Rendering' },
  { id: 'n12', x: 780, y: 200, w: 95, h: 65, label: '12: FINAL QA', name: 'Final QA Gate', detail: 'LLM + checklist', color: '#34d399', status: 'Approved' },
];

const EDGES = [
  // Main pipeline: Discovery -> Extract -> Compare -> Verify
  { from: 'n01', to: 'n02', path: 'M 105 192 L 120 192', color: '#0ea5e9' },
  { from: 'n02', to: 'n03', path: 'M 215 192 L 230 192', color: '#0ea5e9' },
  { from: 'n03', to: 'n04', path: 'M 325 192 L 340 192', color: '#0ea5e9' },
  // Conditional: Verify -> Research (if conflicts)
  { from: 'n04', to: 'n05', path: 'M 387 160 L 387 125', color: '#fbbf24' },
  // Research loops back to Source Comparison
  { from: 'n05', to: 'n03', path: 'M 340 92 C 300 92, 278 130, 278 160', color: '#a855f7' },
  // Verify -> Article Gen (if no conflicts)
  { from: 'n04', to: 'n06', path: 'M 435 192 L 450 192', color: '#34d399' },
  // Article Gen -> Style Validation -> Plagiarism Check
  { from: 'n06', to: 'n07', path: 'M 545 192 L 560 192', color: '#0ea5e9' },
  { from: 'n07', to: 'n08', path: 'M 655 192 L 670 192', color: '#0ea5e9' },
  // Plagiarism -> Rewrite Gate (conditional upward)
  { from: 'n08', to: 'n09', path: 'M 717 160 L 717 125', color: '#fbbf24' },
  // Rewrite Gate -> Rewrite Agent
  { from: 'n09', to: 'n10', path: 'M 670 92 L 655 92', color: '#f97316' },
  // Rewrite loops back to Style Validation
  { from: 'n10', to: 'n07', path: 'M 607 125 L 607 160', color: '#f97316' },
  // Plagiarism -> Image Gen + Final QA (parallel)
  { from: 'n08', to: 'n11', path: 'M 765 175 C 770 155, 775 145, 780 145', color: '#89ceff' },
  { from: 'n08', to: 'n12', path: 'M 765 205 C 770 215, 775 225, 780 225', color: '#34d399' },
];

const LEDGER_ROWS = [
  { id: 'n01', name: 'News Discovery', role: 'Finds news from global sources', status: 'Active', statusColor: 'text-emerald-400 bg-emerald-500/10', dotColor: 'bg-primary' },
  { id: 'n02', name: 'Source Extraction', role: 'Extracts facts, quotes & data', status: 'Active', statusColor: 'text-cyan-400 bg-cyan-500/10', dotColor: 'bg-cyan-400' },
  { id: 'n03', name: 'Source Comparison', role: 'Cross-references multiple sources', status: 'Active', statusColor: 'text-cyan-400 bg-cyan-500/10', dotColor: 'bg-cyan-400' },
  { id: 'n04', name: 'Fact Verification', role: 'Validates numbers, dates & claims', status: 'Evaluating', statusColor: 'text-amber-400 bg-amber-500/10', dotColor: 'bg-amber-400' },
  { id: 'n05', name: 'Deep Research', role: 'Resolves conflicting information', status: 'On demand', statusColor: 'text-purple-400 bg-purple-500/10', dotColor: 'bg-purple-400' },
  { id: 'n06', name: 'Article Generation', role: 'Writes article from verified facts', status: 'Ready', statusColor: 'text-purple-400 bg-purple-500/10', dotColor: 'bg-purple-400' },
  { id: 'n07', name: 'Style Validation', role: 'Checks AlCircle editorial tone', status: 'Ready', statusColor: 'text-emerald-400 bg-emerald-500/10', dotColor: 'bg-emerald-400' },
  { id: 'n08', name: 'Plagiarism Check', role: 'Ensures content originality', status: 'Verified', statusColor: 'text-emerald-400 bg-emerald-500/10', dotColor: 'bg-emerald-400' },
  { id: 'n09', name: 'Rewrite Check', role: 'Decides if revision needed', status: 'Standby', statusColor: 'text-amber-400 bg-amber-500/10', dotColor: 'bg-amber-400' },
  { id: 'n10', name: 'Rewrite Agent', role: 'Revises articles up to 2 times', status: 'On demand', statusColor: 'text-[#f97316] bg-[#f97316]/10', dotColor: 'bg-[#f97316]' },
  { id: 'n11', name: 'Image Generation', role: 'Creates article hero images', status: 'Rendering', statusColor: 'text-secondary bg-secondary-container', dotColor: 'bg-secondary' },
  { id: 'n12', name: 'Final QA', role: 'Last quality review before publish', status: 'Active', statusColor: 'text-emerald-400 bg-emerald-500/10', dotColor: 'bg-emerald-400' },
];

const AgentFlow: React.FC = () => {
  const [hoveredNode, setHoveredNode] = useState<string | null>(null);

  return (
    <div className="flex flex-col w-full">
      {/* Header */}
      <div className="flex items-center justify-between mb-space-base">
        <div>
          <h1 className="font-display text-headline-lg text-on-surface tracking-tight">Agent Pipeline</h1>
          <p className="font-body text-body-sm text-on-surface-variant">12 agents working together to discover, verify, write and publish articles</p>
        </div>
        <div className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-emerald-500/10 rounded-full font-mono text-label-xs text-emerald-600">
          <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
          <span className="font-semibold">12 Agents Active</span>
        </div>
      </div>

      {/* SVG DAG + Policy Panel */}
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-space-md px-gutter-normal mb-space-base">
        <div className="xl:col-span-8 rounded-xl overflow-hidden bg-[#0b0f17] shadow-elevated border border-[#1e293b]">
          {/* Dark header bar */}
          <div className="flex items-center justify-between px-5 py-3 border-b border-[#1e293b]">
            <div className="flex items-center gap-space-xs">
              <span className="material-symbols-outlined text-[#0ea5e9] text-[20px]">account_tree</span>
              <h2 className="font-display text-headline-sm text-[#e2e8f0]">LangGraph State Machine Topology</h2>
            </div>
            <div className="flex items-center gap-3 font-mono text-label-xs">
              <span className="flex items-center gap-1 text-[#94a3b8]"><span className="w-2 h-2 rounded-full bg-emerald-400 shadow-[0_0_6px_rgba(52,211,153,0.6)]" /> Active</span>
              <span className="flex items-center gap-1 text-[#94a3b8]"><span className="w-2 h-2 rounded-full bg-cyan-400 animate-pulse" /> Streaming</span>
              <span className="flex items-center gap-1 text-[#94a3b8]"><span className="w-2 h-2 rounded-full bg-amber-400" /> Eval Loop</span>
              <span className="flex items-center gap-1 text-[#94a3b8]"><span className="w-2 h-2 rounded-full bg-purple-400" /> Fork</span>
            </div>
          </div>

          {/* Dark SVG canvas */}
          <div className="relative w-full h-[320px] select-none bg-[#0b0f17] overflow-hidden p-2">
            <svg className="w-full h-full" viewBox="0 0 900 300">
              <defs>
                {/* Glow filter for flow lines */}
                <filter id="edge-glow" x="-10%" y="-10%" width="120%" height="120%">
                  <feGaussianBlur stdDeviation="2" result="blur" />
                  <feMerge>
                    <feMergeNode in="blur" />
                    <feMergeNode in="SourceGraphic" />
                  </feMerge>
                </filter>
              </defs>

              {/* Subtle grid */}
              <g opacity="0.05" stroke="#334155" strokeDasharray="2 8">
                {[110, 220, 340, 450, 560, 670, 780].map(x => <line key={x} x1={x} x2={x} y1="0" y2="300" />)}
              </g>

              {/* Flow lines — base dim layer */}
              {EDGES.map((edge, i) => (
                <path key={`bg-${i}`} d={edge.path} fill="none" stroke={edge.color} strokeWidth="2" opacity="0.15" />
              ))}

              {/* Flow lines — animated glowing dashes streaming through */}
              {EDGES.map((edge, i) => (
                <path
                  key={`flow-${i}`}
                  d={edge.path}
                  fill="none"
                  stroke={edge.color}
                  strokeWidth="2"
                  strokeDasharray="8 12"
                  filter="url(#edge-glow)"
                  opacity="0.8"
                >
                  <animate attributeName="stroke-dashoffset" from="0" to="-40" dur={`${1 + i * 0.15}s`} repeatCount="indefinite" />
                </path>
              ))}

              {/* Nodes */}
              {NODES.map(node => {
                const isHovered = node.id === hoveredNode;
                return (
                  <g key={node.id} transform={`translate(${node.x}, ${node.y})`}
                    className="cursor-pointer"
                    onMouseEnter={() => setHoveredNode(node.id)}
                    onMouseLeave={() => setHoveredNode(null)}
                  >
                    <rect fill="#181c24" height={node.h} rx="6"
                      stroke={isHovered ? '#0ea5e9' : '#2d3748'}
                      strokeWidth={isHovered ? 2 : 1}
                      width={node.w} className="transition-all" />
                    <rect fill={node.color} fillOpacity="0.1" height="16" rx="3" width={node.w - 10} x="5" y="4" />
                    <circle cx="14" cy="12" fill={node.color} r="3" />
                    <text fill={node.color} fontFamily="JetBrains Mono" fontSize="8" fontWeight="600" x="22" y="15">{node.label}</text>
                    <text fill="#dfe2ee" fontFamily="Space Grotesk" fontSize="10" fontWeight="600" x="8" y="34">{node.name}</text>
                    <text fill="#64748b" fontFamily="Inter" fontSize="8" x="8" y="46">{node.detail}</text>
                    <text fill={node.color} fontFamily="JetBrains Mono" fontSize="7" x="8" y="58">{node.status}</text>
                  </g>
                );
              })}
            </svg>
          </div>

          {/* Dark footer info */}
          <div className="flex items-center justify-between px-5 py-2 border-t border-[#1e293b] text-[11px] font-mono">
            <div className="flex items-center gap-3 text-[#64748b]">
              <span className="flex items-center gap-1.5">
                <span className="w-2 h-2 rounded-full bg-[#0ea5e9]/30 border border-[#0ea5e9]" />
                Active Subgraph: <span className="text-[#e2e8f0] font-medium">Newsroom-Metals-Wire</span>
              </span>
            </div>
            <span className="text-[#475569]">Click any node to inspect</span>
          </div>
        </div>

        {/* Policy Panel */}
        <div className="xl:col-span-4 glass-card p-space-md flex flex-col justify-between">
          <div>
            <div className="flex items-center gap-space-xs border-b border-surface-container-high/60 pb-space-sm">
              <span className="material-symbols-outlined text-secondary text-[20px]">tune</span>
              <h3 className="font-display text-headline-sm text-on-surface">Flow Policy & Routing Rules</h3>
            </div>

            <div className="mt-space-sm space-y-space-sm">
              <PolicyCard
                icon="replay" iconColor="text-amber-400"
                title="Dynamic Fact Retry Guard"
                badge="ENABLED" badgeColor="bg-emerald-500/10 text-emerald-400"
                desc="Max 2 automated loopback retries on fact deviation >5%."
                footer="Threshold: >=95% Confidence"
              />
              <PolicyCard
                icon="fork_right" iconColor="text-purple-400"
                title="Parallel Sub-Graph Fork"
                badge="PARALLEL" badgeColor="bg-primary/10 text-primary"
                desc="Runs Imagen4 concurrently alongside Fact Verification to save 2.1s."
                footer="Fork Join: Node 06 (QA Gate)"
              />
              <PolicyCard
                icon="swap_calls" iconColor="text-cyan-400"
                title="Fast-Path Failover Standby"
                badge="ON" badgeColor="bg-primary/10 text-primary"
                desc="Auto-route to Claude 3.5 Haiku if Sonnet latency exceeds 4.0s."
                footer=""
              />
            </div>
          </div>
        </div>
      </div>

      {/* Orchestration Ledger Table */}
      <div className="px-gutter-normal">
        <div className="glass-card overflow-hidden">
          <div className="px-space-md py-space-sm bg-surface-container-high/60 flex items-center justify-between">
            <div className="flex items-center gap-space-sm">
              <span className="font-display text-headline-sm text-on-surface">Agent Node Orchestration Ledger</span>
              <span className="px-space-xs py-0.5 rounded bg-surface-container-highest text-primary font-mono text-label-xs font-semibold">12 Nodes</span>
            </div>
          </div>
          <div className="overflow-x-auto">
            <table className="w-full text-left font-body text-body-sm">
              <thead className="bg-surface-container-lowest text-outline font-mono text-label-xs uppercase tracking-wider">
                <tr>
                  <th className="py-space-sm px-space-md">Agent</th>
                  <th className="py-space-sm px-space-md">What it does</th>
                  <th className="py-space-sm px-space-md text-center">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-surface-container-high/40 text-on-surface">
                {LEDGER_ROWS.map(row => (
                  <tr key={row.id} className="hover:bg-slate-50 transition-colors">
                    <td className="py-space-sm px-space-md">
                      <div className="flex items-center gap-space-xs">
                        <span className={`w-2.5 h-2.5 rounded-full ${row.dotColor}`} />
                        <span className="font-display text-headline-sm text-on-surface">{row.name}</span>
                      </div>
                    </td>
                    <td className="py-space-sm px-space-md text-on-surface-variant font-body text-body-sm">{row.role}</td>
                    <td className="py-space-sm px-space-md text-center">
                      <span className={`inline-flex items-center gap-1 px-space-xs py-0.5 rounded font-mono text-label-xs ${row.statusColor}`}>
                        <span className={`w-1.5 h-1.5 rounded-full ${row.dotColor}`} />
                        {row.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

const PolicyCard: React.FC<{ icon: string; iconColor: string; title: string; badge: string; badgeColor: string; desc: string; footer: string }> = ({ icon, iconColor, title, badge, badgeColor, desc, footer }) => (
  <div className="p-space-sm bg-surface-container rounded border border-surface-container-highest/60 space-y-1">
    <div className="flex items-center justify-between">
      <span className="font-mono text-label-xs text-on-surface font-semibold flex items-center gap-1">
        <span className={`material-symbols-outlined ${iconColor} text-[14px]`}>{icon}</span>
        {title}
      </span>
      <span className={`px-1.5 py-0.5 ${badgeColor} font-mono text-[10px] rounded`}>{badge}</span>
    </div>
    <p className="text-on-surface-variant text-[11px] leading-relaxed">{desc}</p>
    {footer && (
      <div className="flex items-center justify-between pt-1 font-mono text-label-xs text-outline">
        <span>{footer}</span>
      </div>
    )}
  </div>
);

export default AgentFlow;
